<template>
  <div class="auth auth-login">
    <h1 class="auth-title">
      <template v-if="isThirdPart">{{ projectTitle }}</template>
      <template v-else>{{ projectName }}邀请您登录</template>
    </h1>
    <div class="auth-form__container">
      <div class="auth-form__container-title">手机号登录</div>
      <a-form-model
        ref="loginForm"
        :model="form"
        :rules="rules"
        layout="vertical"
        class="auth-form"
        hideRequiredMark
      >
        <a-form-model-item label="手机号" prop="username">
          <a-input v-model="form.username" placeholder="" />
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password">
          <a-input v-model="form.password" type="password" placeholder="" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            :loading="loading"
            type="primary"
            class="auth-form__submit"
            @click="onSubmit"
          >
            登录
          </a-button>
        </a-form-model-item>
        <a-form-model-item>
          <div class="mp-flex-justify auth-form__footer">
            <router-link :to="`/find-password${urlRedirectQueryStr}`">
              忘记密码
            </router-link>
            <span>
              还没账号？<router-link :to="`/register${urlRedirectQueryStr}`">
                去注册<arrow-right size="16" :strokeWidth="2" />
              </router-link>
            </span>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>

    <img
      src="@/assets/images/auth/auth_person.svg"
      class="auth-login__img-person"
      alt="person"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ArrowRight } from '@icon-park/vue'

import { isThirdPart } from '@/const'
import {
  validateUsername,
  validatePhone,
  validatePassword
} from '@/utils/validate'

export default {
  name: 'Login',
  components: {
    ArrowRight
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!validateUsername(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    const validatePass = (rule, value, callback) => {
      if (!validatePassword(value)) {
        callback(new Error('密码长度8-20位'))
      } else {
        callback()
      }
    }

    return {
      isThirdPart,
      projectName: process.env.VUE_APP_NAME,
      projectTitle: process.env.VUE_APP_TITLE,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, trigger: 'blur', validator: validateName }
        ],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      isKeepLogin: true,
      loading: false,
      responseErr: null
    }
  },
  computed: {
    ...mapState({
      groups: state => state.auth.groups
    }),
    redirect() {
      return this.$route.query && this.$route.query.redirect
    },
    urlRedirectQueryStr() {
      return this.redirect ? `?redirect=${this.redirect}` : ''
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    onSubmit() {
      if (this.loading) {
        return
      }

      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          if (this.responseErr) {
            this.responseErr()
          }

          const usernameField = validatePhone(this.form.username)
            ? 'mobile'
            : 'name'

          const data = {
            [usernameField]: this.form.username,
            password: this.form.password
          }
          const resData = await this.login({
            userInfo: data,
            isKeepLogin: this.isKeepLogin
          })
          if (resData.code === 0) {
            const defaultPath = this.groups?.course ? '/' : '/no-course'
            const path = this.redirect || defaultPath
            this.$router.push({ path })
          } else {
            this.responseErr = this.$message.error({
              content: resData.msg,
              duration: 0
            })
          }

          this.loading = false
        } else {
          return false
        }
      })
    }
  },
  beforeDestroy() {
    this.responseErr && this.responseErr()
  }
}
</script>

<style lang="less">
@import './auth-common.less';

.auth.auth-login {
  .auth-form__container {
    padding-bottom: 72px;
  }

  .auth-login__form {
    .mat-icon {
      margin-right: @spacing-basic;
    }
  }

  .auth-login__img-person {
    position: absolute;
    width: 99px;
    height: 254px;
    bottom: -195px;
    left: 230px;
  }
}
</style>
